import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * Remove a rota `offers/add` das children — usado apenas no resume-shell.
 */
export function withoutOffersAddPage(routes) {
  return routes.map((route) => {
    if (route.path !== 'offers') return route;

    return {
      ...route,
      children: route.children.filter((child) => child.path !== 'add'),
    };
  });
}

/**
 * Redireciona URLs legadas `/products/resume/:id/*` para `/products/resume-shell/:id/*`.
 */
export function ProductResumeLegacyRedirect() {
  const { id } = useParams();
  const location = useLocation();
  const legacyPrefix = `/dashboard/products/resume/${id}`;
  const remainder = location.pathname.startsWith(legacyPrefix)
    ? location.pathname.slice(legacyPrefix.length)
    : '';
  const target = `/dashboard/products/resume-shell/${id}${remainder}${location.search}${location.hash}`;

  return <Navigate to={target} replace />;
}
